import * as React from 'react'
import Link from 'next/link'
import clsx from 'clsx'

export interface InfoCardProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string
  subtitle: string
  href: string
  asNewTab?: boolean
}

export const InfoCard = React.forwardRef<HTMLDivElement, InfoCardProps>(
  ({ className, asNewTab, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={clsx(
          'relative p-4 bg-white rounded-lg border border-subdued',
          className
        )}
        tabIndex={0}
        {...props}
      >
        <div className="flex gap-3 z-10">
          <div className="flex-1">
            <div className="mb-1">
              <Link href={props.href} passHref>
                <a
                  href={props.href}
                  className="overlay-link font-bold text-type-basic-dark text-base"
                  {...(asNewTab && {
                    target: '_blank',
                    rel: 'noreferrer',
                  })}
                >
                  {props.title}
                </a>
              </Link>
            </div>
            <div>
              <p className="text-sm text-subdued">{props.subtitle}</p>
            </div>
          </div>
          <div className="flex justify-center items-center">
            {props.children}
          </div>
        </div>
      </div>
    )
  }
)

InfoCard.displayName = 'InfoCard'
